import { render, staticRenderFns } from "./verificate12306.vue?vue&type=template&id=3f9365d3&"
import script from "./verificate12306.vue?vue&type=script&lang=js&"
export * from "./verificate12306.vue?vue&type=script&lang=js&"
import style0 from "./verificate12306.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports